import React from 'react';
import PropTypes from 'prop-types';
import { MdSearch } from 'react-icons/md';

import { Container, SubmitButton } from './styles';

function TrackInput({ trackingCode, onCodeChange }) {
    return (
        <Container className="input-container">
            <input
                placeholder="digite o seu código aqui"
                onChange={evt => onCodeChange(evt.target.value)}
                value={trackingCode}
                name="input-tracking-code"
                id="input-tracking-code"
            />
            <SubmitButton id="tracking-button" type="submit">
                <MdSearch />
            </SubmitButton>
        </Container>
    );
}

TrackInput.propTypes = {
    trackingCode: PropTypes.string.isRequired,
    onCodeChange: PropTypes.func.isRequired,
};

export default TrackInput;
